import React, { useMemo } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
} from 'recharts';

const DEFAULT_AXES = [
  { slug: 'tdah', label: 'Dynamisme & Attention', max: 10 },
  { slug: 'tsa', label: 'Sensibilité sensorielle', max: 10 },
  { slug: 'dys', label: "Rythme d'apprentissage", max: 10 },
];

const NeuroRadarChart = ({ scores, axisLabels, spectra, compact = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const chartAxes = useMemo(() => {
    if (spectra?.length) {
      return spectra.map((s) => ({
        slug: s.slug,
        label: s.label || axisLabels?.[s.slug] || s.slug,
        max: s.max_score ?? 10,
      }));
    }
    if (axisLabels && scores) {
      return Object.keys(scores).map((slug) => ({
        slug,
        label: axisLabels[slug] || slug,
        max: 10,
      }));
    }
    return DEFAULT_AXES.map((a) => ({
      slug: a.slug,
      label: axisLabels?.[a.slug] || a.label,
      max: a.max,
    }));
  }, [spectra, axisLabels, scores]);

  const data = chartAxes.map((axis) => ({
    axis: axis.label,
    value: scores?.[axis.slug] ?? 0,
    fullMark: axis.max,
  }));

  const maxDomain = Math.max(10, ...chartAxes.map((a) => a.max));
  const height = compact ? 200 : (isMobile ? 360 : 400);
  const outerRadius = compact ? '70%' : '85%';
  const tickSize = compact ? 10 : (isMobile ? 11 : 13);

  return (
    <Box
      sx={{
        width: '100%',
        '& .recharts-radar-polygon': {
          animation: 'neuroRadarPulse 3s ease-in-out infinite',
        },
        '@keyframes neuroRadarPulse': {
          '0%, 100%': { fillOpacity: 0.35 },
          '50%': { fillOpacity: 0.65 },
        },
      }}
    >
      <ResponsiveContainer width="100%" height={height}>
        <RadarChart data={data} cx="50%" cy="50%" outerRadius={outerRadius}>
          <PolarGrid stroke="#e0d5cc" />
          <PolarAngleAxis dataKey="axis" tick={{ fill: '#784e3c', fontSize: tickSize }} />
          <PolarRadiusAxis angle={90} domain={[0, maxDomain]} tick={{ fontSize: 10, fill: '#784e3c' }} />
          <Radar
            name="Profil"
            dataKey="value"
            stroke="#784e3c"
            fill="#c4a088"
            fillOpacity={0.5}
            isAnimationActive
            animationDuration={800}
          />
        </RadarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default NeuroRadarChart;
